import type { LucideIcon } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: number | string;
  icon: LucideIcon;
  description?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  color?: 'blue' | 'green' | 'yellow' | 'red' | 'purple' | 'gray';
}

const colorClasses = {
  blue: 'bg-blue/10 text-blue',
  green: 'bg-sage/20 text-sage',
  yellow: 'bg-gold/20 text-gold',
  red: 'bg-red/10 text-red',
  purple: 'bg-rose/20 text-rose',
  gray: 'bg-gray-warm/30 text-sepia/70'
};

export function StatsCard({
  title,
  value,
  icon: Icon,
  description,
  color = 'blue'
}: StatsCardProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-warm p-6">
      <div className="flex items-center gap-4">
        <div className={`p-3 rounded-lg ${colorClasses[color]}`}>
          <Icon className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm font-medium text-sepia/70">{title}</p>
          <p className="text-2xl font-semibold text-ink">{value.toLocaleString()}</p>
          {description && <p className="text-xs text-sepia/50 mt-1">{description}</p>}
        </div>
      </div>
    </div>
  );
}
